import { api } from '@/axios/instance/api';
import { type Company, type Idp, type Region } from '@/types';

export const fetchCompanies = () => {
  return api.get<Company[]>('/companies');
};

export const fetchAllRegions = () => api.get<Region[]>(`regions`);

export const fetchIDPs = () => api.get<Idp[]>(`/idps`);

export const updateCompanyImage = (companyId: number, image: File) => {
  const formData = new FormData();
  formData.append('logo_image', image);

  return api.patch(`/companies/${companyId}/upload-logo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteCompanyImage = async (companyId: number) => api.delete(`/companies/${companyId}/delete-logo`);

export const updateCompany = (companyId: number, data: Partial<Company>) =>
  api.patch<Company>(`/companies/${companyId}`, data);
